<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <Title title="グループの編集">
                <v-spacer />
                <TitleButton
                    icon="mdi-floppy"
                    name="保存"
                    @click="onClickSave()" />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container>
                    <v-form ref="form">
                        <v-row dense>
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.name" 
                                    clearable 
                                    label="グループ名" 
                                    outlined 
                                    type="text" 
                                    counter="20"
                                    :rules="[validatorRequire,validatorNameLength]" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        props: {
            groups: {
                type: Array,
                default: []
            },
        },
        components: {
            Title,
            TitleButton,
            Confirm
        },
        data: function () {
            return {
                isView: false,
                editItems: {
                    name: "",
                },
                targetGroup: null,
                validatorRequire: value => !!value || '必須入力です。',
                validatorNameLength: value => value.length <= 20 || '20文字以内で入力して下さい。',
            }
        },
        methods: {
            onClickSave: function () {
                console.log("onClickSave")
                if (!this.$refs.form.validate()) {
                    console.log("input error!!")
                    return
                }

                const self = this
                const userUID = this.$store.getters["userUID"]

                this.$refs.confirm.show({
                    title: "グループの登録",
                    message: "グループを登録しますか？",
                    buttonYes: "登録する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        var placeGroup = self.targetGroup
                        if (placeGroup == null) {
                            var id = 1
                            if (self.groups.length >= 1) {
                                id = Math.max(...self.groups.map(m => m.placeGroupID)) + 1
                            }
                            placeGroup = {
                                version: "1.0.0",
                                placeGroupID: id,
                                name: self.editItems.name,
                                register: {
                                    userUID: userUID,
                                    dateTime: self.df_currentDateTime()
                                },
                                updater: {
                                    userUID: "",
                                    dateTime: ""
                                },
                            }
                        } else {
                            placeGroup.name = self.editItems.name,
                            placeGroup.updater.userUID = userUID,
                            placeGroup.updater.dateTime = self.df_currentDateTime()
                        }
                        db.collection("users").doc(userUID).collection("managements").doc("place_group").collection("groups").doc(""+placeGroup.placeGroupID).set(placeGroup).then(function() {
                            self.$store.commit("notification", {message:"グループを登録しました。", isError:false})
                            if (self.targetGroup == null) {
                                self.groups.push(placeGroup)
                            }
                            self.isView = false
                        }).catch (function (error) {
                            self.$store.commit("notification", {message:"グループの登録に失敗しました。", isError:true})
                        })
                        return true
                    },
                })
            },
            show: function (targetGroup) {
                if (targetGroup != null) {
                    this.targetGroup = targetGroup
                    this.editItems.name = targetGroup.name
                }
                this.isView = true
            }
        }
    }
</script>
